import 'immutability-helper';
import '../../../../router/helpers/initRouter.js';
import '../../../../router/routes/dev/model.js';
import '../../../../router/routes/dev/routes.js';
import '../../../../router/routes/dashboard/model.js';
import '../../../../router/routes/pro/model.js';
import '../../../../router/routes/visitsPage/model.js';
import '@caresend/types';
import '../../../../router/routes/orderFlow/model.js';
import '../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../router/routes/orderFlow/routes.js';
import '../../../../router/routes/schedulingFlow/model.js';
import '../../../../router/routes/schedulingFlow/routes.js';
import { ChartingFlowRouteName } from '../../../../router/routes/chartingFlow/model.js';
import '../../../../router/routes/chartingFlow/routes.js';
import '../../../../router/routes/portal/portalRoutes.js';
import '../../../../router/routes/portal/model.js';
import '../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../helpers/initStore.js';

const specimenBagsCompletionAction = async (route) => {
    const store = getStore();
    const { orderID } = route.params;
    if (!orderID)
        return null;
    await store.dispatch('chartingFlow/completeCharting', orderID);
    return null;
};
/**
 * If a completion action is defined, the next button will trigger that action
 * rather than being a `<router-link>` to the next step. While the async action
 * is in progress, a loader will show on the next button. If the promise
 * resolves, the user will be navigated to the next step.
 *
 * **To cancel navigation, an error must be thrown.** Errors thrown within these
 * actions will be shown to the user and prevent navigation to the next step.
 */
const chartingFlowCompletionActions = {
    [ChartingFlowRouteName.SPECIMEN_BAGS]: specimenBagsCompletionAction,
};

export { chartingFlowCompletionActions };
